import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Editor } from "@tinymce/tinymce-react";
export default function MyEditor(_a) {
    var value = _a.value, initialValue = _a.initialValue, editorRef = _a.editorRef, onEditorChange = _a.onEditorChange;
    return (_jsx(_Fragment, { children: _jsx(Editor, { tinymceScriptSrc: process.env.PUBLIC_URL + "/tinymce/tinymce.min.js", onInit: function (_evt, editor) { return (editorRef.current = editor); }, initialValue: initialValue, value: value, init: {
                promotion: false,
                branding: false,
                height: 500,
                menubar: false,
                plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "fullscreen",
                    "insertdatetime",
                    "media",
                    "table",
                    "preview",
                    "help",
                    "wordcount",
                ],
                toolbar: "undo redo | blocks | " +
                    "bold italic forecolor | alignleft aligncenter " +
                    "alignright alignjustify | bullist numlist outdent indent | " +
                    "removeformat | help",
                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            }, onEditorChange: onEditorChange }) }));
}
